import React from 'react'
import { Badge } from 'antd'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { useInventory, usePet } from '../../modules'

import Receive from '../../components/reusable/receive'

import Home from './Home'
import OpNotes from './OpNotes'
import Document from './Document'
import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

let menu = [], storeName = "Theatre"

const Theatre = () => {
    const location = useLocation()
    const split = location.pathname.split('/')

    const [Inventory, store, requests] = useInventory(storeName)

    const { user } = useSelector(state => state.application)

    const [{ loading, error }] = usePet('singleSaleItem', { name: 'Theatre Operations' }, { notify: true, callback: ({ data }) => {
        let docs = (data?.attached ?? []).map(doc => ({
            path: doc.name.toLowerCase().replace(' ', '-'),
            _id: doc._id,
            title: doc.name,
            component: () => <Document document={ doc } />
        }))

        menu = [
            {
                path: '',
                title: 'Home',
                component: Home
            },
            {
                path: 'operation-notes',
                title: 'Operation Notes',
                component: OpNotes
            },
            ...docs
        ]

        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[3] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory path={ path } storeName={ storeName } />
            }
    } })

    const page = split[3]

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <Receive
                progress
                loading={ loading }
                error={ error }>
                <div className="w-1/6 overflow-y-scroll">
                    <p className="text-2xl font-semibold">Theatre</p>
                    <SideMenu namespace="theatre" menu={ menu } />
                </div>
                <div className="w-5/6 overflow-y-scroll">
                    <Routing namespace="theatre" menu={ menu } />
                </div>
            </Receive>
        </div>
    )
}

export default Theatre